import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/auth/auth-context';

/** Protege as rotas internas: sem sessão → manda pro login. */
export function RequireAuth() {
  const { usuario, carregando } = useAuth();
  if (carregando) {
    return (
      <div className="d-flex vh-100 align-items-center justify-content-center text-secondary">
        <div className="spinner-border text-theme-1 me-2" role="status" />
        Carregando…
      </div>
    );
  }
  if (!usuario) return <Navigate to="/login" replace />;
  return <Outlet />;
}
